(() => {
  'use strict';
  const init = root => {
    if (root.dataset.garmentInformationReady) return;
    const trigger = root.querySelector('[data-size-guide-open]');
    const dialog = root.querySelector('[data-size-guide-dialog]');
    if (!trigger || !dialog) return;
    root.dataset.garmentInformationReady = 'true';
    trigger.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('hr-garment-guide-open');
    });
    dialog.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('hr-garment-guide-open');
      trigger.focus({ preventScroll: true });
    });
  };
  const start = scope => {
    if (scope.matches?.('[data-garment-information]')) init(scope);
    scope.querySelectorAll?.('[data-garment-information]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document)); else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
